<ui-multi-select-filter
  class="w-full"
  [filterArray]="filterArray"
  (filterArrayChange)="filterArray = $event; filterArrayChange.emit($event)"
  [filterTypes]="filterTypes"
  [filterFieldsWidthClass]="filterFieldsWidthClass"
  [filterTypeEnableScroll]="true"
  [filterTypeMaxVisibleItems]="filterTypeMaxVisibleItems"
  [maxFilters]="maxFilters"
  [showFilterLabel]="false"
  [clearFiltersDisabled]="!hasActiveFilters"
  [addFilterLabel]="'customer-list.Add_Filter' | translate"
  [clearFiltersLabel]="'customer-list.Clear_Filters' | translate"
  [filterByPlaceholder]="'app.All' | translate"
  [searchPlaceholder]="'customer-list.Search' | translate"
  [allOptionLabel]="'app.All' | translate"
  [allValuesText]="'app.All' | translate"
  [multipleSelectedText]="'customer-list.Items_selected' | translate"
  [valueSearchPlaceholder]="'customer-list.Search' | translate"
  [removeFilterLabel]="'customer-list.Remove_Filter' | translate"
  [usedFilterTooltip]="'customer-list.Filter_Already_Used' | translate"
  [maxFiltersTooltip]="'customer-list.Max_Filters_Reached' | translate: { max: maxFilters }"
  (searchTriggered)="searchTriggered.emit()"
  (searchInputCleared)="searchInputCleared.emit($event.filterIndex)"
  (filterRemoved)="searchTriggered.emit()"
  (clearFiltersClicked)="clearFiltersClicked.emit()"
></ui-multi-select-filter>
